import axios from 'axios'
const { REACT_APP_API_URL, REACT_APP_API_KEY } = process.env

export const BE_API = axios.create({
  baseURL: REACT_APP_API_URL,
  headers: {
    'X-Gateway-APIKey': REACT_APP_API_KEY,
  }
})

const apis = {
  user: {
    authenticate: token => BE_API.get('/user/details', { headers: { Authorization: `Bearer ${token}` } })
  },
  store: {
    list: () => BE_API.get('/stores')
  },
  tills: {
    getStatus: (storeId) => BE_API.get('/queue/getStatus', { params: { 
      storeId, 
      queueId: +storeId === 10 ? 2 : 1 
    } }),
    setStatus: (tillId, status) => BE_API.post('/till/setStatus', { tillId, status }),
    call: (tillId) => BE_API.get('/till/till_call', { params: { tillId } }),
  }
}
export default apis